import DOMPurify from 'dompurify';
import { Box } from '@mui/material';

const MailContent = ({ htmlContent }) => {

    const extractBodyContent = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.innerHTML; // Contenu de <body>
    };

    const sanitizedBody = DOMPurify.sanitize(extractBodyContent(htmlContent));

    return (
        <Box
            sx={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                maxHeight: '800px',
                overflow: 'auto',
                backgroundColor: '#fff',
            }}
            dangerouslySetInnerHTML={{ __html: sanitizedBody }}
        />
    );
};

export default MailContent;